import React  from 'react';
import {useEffect, useState} from "react";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {
    Avatar,
    Box,
    Button,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    Select,
    TextField,
    Typography
} from "@material-ui/core";
import CustomTable from "../../component/customTable/CustomTable";
import {Pagination} from "@material-ui/lab";
import CashUsersInfo from "../CashUsersInfo/CashUsersInfo";
import searchIcon from "../../assets/images/search-normal.svg"
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {CashUsersService} from "./CashUsersService";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {useLocation} from "react-router-dom";
import {useScrollBy} from "react-use-window-scroll";

let selectedItemId = -1
const CashUsers = ({isMain = true, rowOnClicked}) => {
    let page = 0

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new CashUsersService(fundID, token, snackbar, loading)

    const [filterText, setFilterText] = useState("");
    const [filterSelectedValue, setFilterSelectedValue] = useState(1);


    const [pageCount, setPageCount] = useState(0);
    const [itemCount, setItemCount] = useState(0);

    const [usersList, setUsersList] = useState([]);
    const [needRefresh, setNeedRefresh] = useState(false);


    const handleChange = (event, value) => {
        page = value - 1
        getListDataFromServer()
    };


    const showEventsContent = (rowId, index) => {
        if (isMain) {
            selectedItemId = rowId
            setOpenDialog(true);
        } else {
            rowOnClicked({
                id: rowId,
                name: usersList[index].name,
                phoneNumber: usersList[index].phoneNumber,
                personalCode: usersList[index].nationalCode,
                group: usersList[index].cash_group,
            })
        }
    }


    const [openDialog, setOpenDialog] = useState(false);

    const handleClose = () => {
        if (needRefresh) {
            selectedItemId = -1
            setNeedRefresh(false)
            getListDataFromServer()
        }
        setOpenDialog(false);
    };

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getListDataFromServer()
        }
    }, [])

    function getListDataFromServer(filter = filterText, filterSelect = filterSelectedValue) {
        loading(setLoadingStateDispatch(true))
        service.getCashUsersList(
            page,
            fundID,
            filterSelect === 1 ? filter : "",
            filterSelect === 2 ? filter : "",
            filterSelect === 3 ? filter : "",
        ).then(response => {
            setUsersListData(response)
            loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason,"خطا در دریافت اطلاعات اعضا!",snackbar,loading)
        })
    }

    function prepareUsersJsonList(id, rowNumber, firstName, lastName, groupName, phoneNumber, nationalCode, enabled, avatarUrl) {
        return {
            id: id,
            number: rowNumber,
            name: `${firstName} ${lastName}`,
            nationalCode: nationalCode,
            cash_group: groupName,
            phoneNumber: phoneNumber ? phoneNumber : "-",
            state: enabled ? <span className="bg_active_state">فعال</span> :
                <span className="bg_deActive_state">غیر فعال</span>,
            avatar: <section className="w-100 d-flex justifyContentCenter">
                <Avatar
                    src={avatarUrl}
                    style={{
                        width: '38px',
                        height: '38px',
                        alignSelf: 'center',
                        cursor: 'pointer',
                        background: 'linear-gradient(270deg, #FAFAFA 0%, #f7f7f7 100%)'
                    }}/>
            </section>
        }
    }

    function setUsersListData(usersData) {
        setItemCount(usersData.numberOfItems)
        setPageCount(usersData.totalPage)
        setUsersList([])

        usersData.data.map((item, index) => {
            setUsersList((prevState => [...prevState,
                prepareUsersJsonList(
                    item.id,
                    (page * 20) + index + 1,
                    item.firstName,
                    item.lastName,
                    item.groupName,
                    item.phoneNumber,
                    item.nationalCode,
                    item.enabled,
                    item.avatarUrl
                )
            ]))
        })
    }
    const scrollBy = useScrollBy();
    useEffect(() => {
        scrollBy(0,0)
    }, []);


    return (
        <>
            {
                <CashUsersInfo
                    openDialog={openDialog}
                    handleClose={handleClose}
                    selectedItemId={selectedItemId}
                    needRefresh={setNeedRefresh}
                />
            }
            <section className='pageContainer'>

                <Box className={`${isMain ? "d-flex flex-row w-100" : "d-none"}`}
                     sx={{
                         margin: '1rem 0 1.2rem 0',
                         justifyContent: 'center',
                         alignContent: 'center',
                         alignItems: 'center'
                     }}>
                    <section className='d-flex flex-column flex-nowrap flex-grow-1'
                             style={{alignItems: 'start'}}>
                        <Typography variant={"h5"}>
                            اعضا
                        </Typography>
                        {itemCount > 0 ?
                            <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                                {" " + itemCount + " عضو ثبت شده "}
                            </Typography> :
                            ''}
                    </section>
                    <Button
                        className={`${isMain ? "d-block" : "d-none"}`}
                        variant='contained'
                        onClick={() => {
                            selectedItemId = -1
                            setOpenDialog(true);
                        }}
                        // startIcon={<DeleteIcon/>}
                    >
                        افزودن عضو جدید
                    </Button>
                </Box>
                <Box style={{display: "flex", flexWrap: "wrap"}} sx={{margin: '0 0 1.2rem 0'}}>
                    <Grid sm={12} md={8} lg={9} xl={9} className='modalTextFieldContainer'>
                        <TextField
                            value={filterText}
                            onChange={e => {
                                setFilterText(e.target.value)
                                getListDataFromServer(e.target.value)
                            }}
                            className='w-100'
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <img src={searchIcon} alt=""/>
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined" label="جستجو"
                            placeholder="عبارت مورد نظر را وارد نمایید..."/>
                    </Grid>
                    <Grid sm={12} md={4} lg={3} xl={3} className='modalTextFieldContainer'>
                        <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="filled-age-native-simple">جستجو بر اساس</InputLabel>
                            <Select
                                label="جستجو بر اساس"
                                value={filterSelectedValue}
                                onChange={e => {
                                    setFilterSelectedValue(e.target.value)
                                    getListDataFromServer(filterText, e.target.value)
                                }}
                            >
                                <option value={1}>نام و نام خانوادگی</option>
                                <option value={2}>کد ملی</option>
                                <option value={3}>نام گروه</option>
                            </Select>
                        </FormControl>
                    </Grid>

                </Box>


                <CustomTable
                    header={columns}
                    data={usersList}
                    rowClicked={showEventsContent}
                />
                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>
            </section>
        </>
    )

}

export default CashUsers;


const columns = [
    {id: 'number', label: '#', align: 'right'},
    {id: 'avatar', label: 'نمایه', align: 'right'},
    {id: 'name', label: 'نام و نام خانوادگی', align: 'right'},
    {id: 'nationalCode', label: 'کد ملی', align: 'right'},
    {id: 'cash_group', label: 'گروه', align: 'right'},
    {id: 'phoneNumber', label: 'شماره همراه', align: 'right'},
    {id: 'state', label: 'وضعیت', align: 'right'},
];

